import { useConfigProvider } from '@/providers/ConfigProvider/ConfigContext';
import {
  isModuleActive,
  Modules,
} from '@/providers/ConfigProvider/ConfigProvider';

const useIsEngravingActivated = (): boolean => {
  const { moduleActivations } = useConfigProvider();
  const isEngravingActivated = isModuleActive(
    moduleActivations,
    Modules.ENGRAVING,
  );

  return !!isEngravingActivated;
};

export { useIsEngravingActivated };
